import type { BootstrapVueOptions } from 'bootstrap-vue-next';

export const legacyBootstrapOptions = {
  components: {
    BModal: {
      teleportTo: '#bootstrap-portals',
    },
  },
} satisfies BootstrapVueOptions;
